var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgApi(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 89,
    height: 89,
    viewBox: "0 0 89 89",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M88.9967 44.4967C88.9967 44.4967 89.5245 24.049 77.2376 11.7623C64.951 -0.524231 44.5033 0.00329905 44.5033 0.00329905C44.5033 0.00329905 44.5004 0.108616 44.5 0.308619C44.5 0.224151 44.4992 0.156577 44.4988 0.106679C44.4979 0.0384459 44.4967 0.00329905 44.4967 0.00329905C44.4967 0.00329905 24.049 -0.524231 11.7623 11.7623C-0.524231 24.049 0.00329905 44.4967 0.00329905 44.4967C0.00329905 44.4967 20.4513 45.0241 32.7376 32.7376C43.9681 21.5076 44.493 3.45909 44.5 0.438575C44.5074 3.45909 45.0323 21.5076 56.2624 32.7376C68.5489 45.0241 88.9967 44.4967 88.9967 44.4967ZM11.7623 77.2376C-0.524231 64.951 0.00329905 44.5033 0.00329905 44.5033C0.00329905 44.5033 20.4513 43.9759 32.7376 56.2624C43.9681 67.4925 44.493 85.5409 44.5 88.5616C44.5074 85.5409 45.0323 67.4925 56.2624 56.2624C68.5489 43.9759 88.9967 44.5033 88.9967 44.5033C88.9967 44.5033 89.5245 64.951 77.2376 77.2376C64.951 89.5241 44.5033 88.9967 44.5033 88.9967C44.5033 88.9967 44.5004 88.8912 44.5 88.6914C44.4996 88.8912 44.4967 88.9967 44.4967 88.9967C44.4967 88.9967 24.049 89.5241 11.7623 77.2376Z",
    fill: "#C0B6F2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApi);
export default __webpack_public_path__ + "static/media/api.caea3c758fb8ad6c3fde91aec68c954e.svg";
export { ForwardRef as ReactComponent };